<template>
  <div>
    <div class="mod-org__post" v-show="$route.name === 'organization'">
      <!-- 查询框 -->
      <el-row class="search-box">
        <div class="search-box-left flex-grow">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item label="岗位名称：">
              <el-input v-model="dataForm.postName" placeholder="名称模糊搜索" clearable></el-input>
            </el-form-item>
            <el-form-item label="岗位名称：" v-show="false">
              <el-input v-model="dataForm.postName" placeholder="名称模糊搜索" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="getDataList(1)" type="primary">{{ $t('query') }}</el-button>
              <el-button @click="reset()">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <el-row style="margin-bottom: 10px;">
        <el-button type="primary" :loading="dataListLoading" @click="addOrUpdataHandle()">新建岗位</el-button>
      </el-row>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%; max-width: 100%;">
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column type="index" label="序号" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="postName" label="岗位名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="postDescribe" label="岗位说明" header-align="center" align="center"></el-table-column>
        <el-table-column prop="authMenuList" label="权限" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">{{scope.row.authMenuList | formatAuthMenuList}}</div>
              <div class="ellipsis">{{scope.row.authMenuList | formatAuthMenuList}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-show="!scope.row.manager" @click="addOrUpdataHandle(scope.row.postId)">{{ $t('update') }}</el-button>
            <el-button type="text" size="small" @click="serachEmployeeHandle(scope.row)">查看员工</el-button>
            <el-button type="text" size="small" v-show="!scope.row.manager" @click="deleteHandle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="getDataList">
      </el-pagination>
      <post-employee v-if="postEmployeeVisible" ref="postEmployee" @refreshDataList="getDataList"></post-employee>
      <post-delete v-if="postDeleteVisible" ref="postDelete" @refreshDataList="getDataList"></post-delete>
    </div>
    <div v-show="$route.name !== 'organization'">
      <router-view/>
    </div>
  </div>
</template>
<script>
import PostEmployee from './post-employee'
import PostDelete from './post-delete'
export default {
  data () {
    return {
      dataListLoading: false,
      dataForm: {
        postName: ''
      },
      dataList: [],
      // 分页
      page: 1,
      limit: 10,
      total: 0,
      postEmployeeVisible: false,
      postDeleteVisible: false
    }
  },
  components: {
    PostEmployee,
    PostDelete
  },
  watch: {
    '$route' (to, from) {
      this.getDataList(1)
    }
  },
  mounted () {
    this.getDataList(1)
  },
  activated () {
    this.getDataList(1)
  },
  filters: {
    formatAuthMenuList (list) {
      if (list.length === 0) {
        return ''
      }
      return list.map(item => { return item.packageName }).join('、')
    }
  },
  methods: {
    // 重置
    reset () {
      this.dataForm.postName = ''
      this.getDataList(1)
    },
    // 获取列表数据
    getDataList (page = this.page) {
      this.page = page
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/custorg/postPageList`, {
        postName: this.dataForm.postName,
        companyId: this.$store.state.user.defaultCompanyId,
        page: page,
        limit: this.limit
      })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            return false
          }
          this.dataList = res.data.data || []
          this.total = res.data.count
        }).catch(() => {
          this.dataListLoading = false
        })
    },
    pageSizeChangeHandle (val) {
      this.limit = val
      this.getDataList(1)
    },
    // 新增编辑
    addOrUpdataHandle (id) {
      this.$router.push({
        name: 'postAddOrUpdate',
        query: {
          pid: id || ''
        }
      })
    },
    // 删除岗位
    deleteHandle (row) {
      this.postDeleteVisible = true
      this.$nextTick(() => {
        this.$refs.postDelete.postId = row.postId
        this.$refs.postDelete.init()
      })
      // this.$confirm('确认删除该岗位设置吗?', '删除岗位', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      //   this.$message({
      //     type: 'success',
      //     message: '删除成功!'
      //   })
      //   this.delete(row)
      // }).catch(() => { })
    },
    // 查看员工
    serachEmployeeHandle (row) {
      this.postEmployeeVisible = true
      this.$nextTick(() => {
        this.$refs.postEmployee.postId = row.postId
        this.$refs.postEmployee.init()
      })
    }
  }
}
</script>
<style lang='scss' scoped>
// .mod-org__post{}
</style>
